import globalStyles from '../../styles/ButtonGradient.module.css';
import styles from './ViewCoachRequestButton.module.css';
import { FiUserPlus } from 'react-icons/fi';

const ViewCoachRequestButton = ({ onClick, pendingCount = 0 }) => {
  return (
    <div className={styles.wrapper}>
      <button className={globalStyles.button} onClick={onClick}>
        <FiUserPlus className={globalStyles.icon} />
        Coach Requests
      </button>
      {pendingCount > 0 && (
        <span className={styles.badge}>{pendingCount}</span>
      )}
    </div>
  );
};

export default ViewCoachRequestButton;
